import { render } from "./BaseSimpleTitle.vue?vue&type=template&id=79c3bd33"
import script from "./BaseSimpleTitle.vue?vue&type=script&lang=js"
export * from "./BaseSimpleTitle.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "79c3bd33"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79c3bd33', script)) {
    api.reload('79c3bd33', script)
  }
  
  module.hot.accept("./BaseSimpleTitle.vue?vue&type=template&id=79c3bd33", () => {
    api.rerender('79c3bd33', render)
  })

}

script.__file = "src/ui/BaseSimpleTitle.vue"

export default script